var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50774 30.0428C10.9145 32.0095 14.7439 32.5807 18.3343 31.9339C18.7646 31.8564 19.0686 31.4826 19.0566 31.0453C19.0446 30.6079 18.7203 30.2512 18.2863 30.1974C18.1774 30.1842 18.0683 30.1691 17.9595 30.1526C17.568 30.1211 17.1764 30.0708 16.7864 30.0013C15.4088 29.7561 14.0494 29.2712 12.7671 28.5309C7.2573 25.3498 5.11672 18.574 7.59757 12.8763C7.95981 12.0442 7.69887 11.098 6.96108 10.5693C6.22351 10.0409 5.24329 10.0977 4.57205 10.7079C3.70691 11.4945 2.9466 12.4262 2.33064 13.4933C-1.41989 19.9895 1.78574 26.7391 7.50774 30.0428Z",
    fill: "#FF6600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50766 2.33876C4.10089 4.30544 1.69134 7.33644 0.45666 10.769C0.308574 11.1806 0.480189 11.6304 0.864986 11.8388C1.24952 12.0472 1.72088 11.9451 1.98457 11.5956C2.05036 11.508 2.11792 11.4213 2.1867 11.3352C2.40989 11.0117 2.64881 10.698 2.90399 10.395C3.80542 9.32442 4.90522 8.38948 6.18719 7.64943C11.697 4.46834 18.6352 6.0027 22.3292 10.9997C22.8688 11.7294 23.8193 11.9764 24.6459 11.6016C25.472 11.2271 25.9128 10.3499 25.72 9.46352C25.4718 8.32094 25.0442 7.19685 24.4282 6.13008C20.678 -0.3665 13.2297 -0.964949 7.50766 2.33876Z",
    fill: "#52CE00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5002 16.1909C31.5002 12.2573 30.0801 8.65508 27.7247 5.86925C27.4424 5.53548 26.9671 5.45919 26.5946 5.68786C26.2213 5.91677 26.0742 6.37615 26.2451 6.77916C26.2878 6.88024 26.3291 6.98208 26.3694 7.08464C26.538 7.43914 26.6899 7.80343 26.825 8.17595C27.3014 9.49193 27.5613 10.9115 27.5613 12.3918C27.5613 18.7541 22.7635 23.9957 16.5889 24.6962C15.6872 24.7985 14.998 25.4981 14.9089 26.4012C14.8203 27.3042 15.3595 28.1246 16.2239 28.4007C17.3374 28.7565 18.5243 28.9489 19.7562 28.9489C27.2578 28.9489 31.5002 22.7978 31.5002 16.1909Z",
    fill: "#2A7FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSymbol);
export default __webpack_public_path__ + "static/media/logoSymbol.867385a7a0228e9eb17b20c3cef08011.svg";
export { ForwardRef as ReactComponent };